import script from "./MyGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./MyGallery.vue?vue&type=script&setup=true&lang=js"

import "./MyGallery.vue?vue&type=style&index=0&id=ee0acc1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee0acc1c"]])

export default __exports__